import { Component, ComponentInterface, h, Host, JSX, Prop, State } from '@stencil/core';
import ChevronUp from './icons/bds_chevron-up_24.svg';
import Close from './icons/bds_close_24.svg';
import InfoCircle from './icons/bds_info-circle_24.svg';

const icons = {
  ARROW_UP: ChevronUp,
  CLOSE: Close,
  INFO: InfoCircle,
};

@Component({
  tag: 'cmm-icon',
  styleUrl: 'cmm-icon.scss',
  shadow: true,
})
export class Icon implements ComponentInterface {
  @State() icon: string;

  @Prop() name: string;

  public connectedCallback(): void {
    if (this.name) {
      this.icon = icons[this.name];
    }
  }

  public render(): JSX.Element {
    if (!this.icon) {
      return false;
    }

    return (
      <Host>
        <div class="cmm-icon" innerHTML={this.icon} />
      </Host>
    );
  }
}
